import { appConfigs } from './appConfigs';
import { createConfig } from './createConfig';
import { Configs } from './types';

export const buildConfig = createConfig(
  appConfigs,
  process.env.REACT_APP_ENVIRONMENT as keyof Configs,
);
